import { useEffect, useState } from "react";
import { getUsersByModule } from "@/api/module.service";
import { MODULE_ID } from "@/api/escala.service";

// Nome de cada usuário do módulo, buscado uma vez: o mesmo autor aparece em várias linhas.
// Falhar aqui não impede a tela, só deixa os nomes em branco.
export function useAutoresDaEscala(clientId: string) {
  const [autores, setAutores] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    let cancelado = false;
    getUsersByModule(MODULE_ID, clientId)
      .then((usuarios) => !cancelado && setAutores(new Map(usuarios.map((u) => [u.user_id, u.user_name]))))
      .catch(() => {});
    return () => {
      cancelado = true;
    };
  }, [clientId]);

  return autores;
}
